import registerForRails from 'js/utils/registerForRails';
import UnibrowChooser from 'js/unibrows/UnibrowChooser';

registerForRails({ UnibrowChooser }, ['js/unibrows/UnibrowChooser']);
